/* Lumora v34 sections: zoom hero slideshow, card slider arrows, before/after hint */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  var FX = ['fade', 'slide', 'slideup', 'slidedown', 'wipe', 'diagonal', 'circle', 'split', 'curtain', 'blinds', 'blur', 'rotate', 'zoomthrough', 'flip', 'cube', 'bounce'];
  var MO = ['zoomout', 'zoomin', 'panleft', 'panright', 'panup', 'pandown', 'drift', 'spin'];

  function hero(root) {
    if (root.__kz) return; root.__kz = true;
    var slides = $$('.kzh__slide', root), dots = $$('[data-kz-dot]', root);
    var fxSet = root.getAttribute('data-fx'), moSet = root.getAttribute('data-mo');
    var auto = root.getAttribute('data-auto') === 'true' && !reduce, ms = parseInt(root.getAttribute('data-int'), 10) || 6000;
    var cur = 0, timer = 0, locked = false, mix = 0, hold = false;
    function pick(set, list, n) { return set === 'mix' ? list[n % list.length] : set; }
    function prep(sl, n, dir) {
      fxSet = root.getAttribute('data-fx'); moSet = root.getAttribute('data-mo');
      sl.setAttribute('data-fx', pick(fxSet, FX, n + 1));
      sl.setAttribute('data-mo', reduce ? 'none' : pick(moSet, MO, n));
      sl.style.setProperty('--d', dir);
    }
    slides[0].setAttribute('data-mo', reduce ? 'none' : pick(moSet, MO, 0));
    function mark(i) { dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); }); }
    function go(i, dir) {
      if (slides.length < 2) return;
      i = (i + slides.length) % slides.length;
      if (i === cur || locked) return;
      locked = true; dir = dir || 1; mix++;
      var from = slides[cur], to = slides[i];
      prep(to, mix, dir);
      from.setAttribute('data-fx', to.getAttribute('data-fx')); from.style.setProperty('--d', dir);
      slides.forEach(function (s) { if (s !== from && s !== to) s.classList.remove('is-on', 'is-out'); });
      from.classList.remove('is-on'); from.classList.add('is-out');
      to.classList.remove('is-out'); to.classList.add('is-on');
      cur = i; mark(i);
      var t = parseFloat(getComputedStyle(root).getPropertyValue('--kz-t')) * 1000 || 1000;
      setTimeout(function () { from.classList.remove('is-out'); locked = false; }, t + 80);
      restart();
    }
    function next() { go(cur + 1, 1); } function prev() { go(cur - 1, -1); }
    function restart() {
      clearTimeout(timer); if (!auto || hold || document.hidden) return;
      timer = setTimeout(next, ms);
      mark(cur); // restarts the progress bar animation
      var d = dots[cur]; if (d) { d.classList.remove('is-on'); void d.offsetWidth; d.classList.add('is-on'); }
    }
    var n = $('[data-kz-next]', root), p = $('[data-kz-prev]', root);
    if (n) n.addEventListener('click', next); if (p) p.addEventListener('click', prev);
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k, k > cur ? 1 : -1); }); });
    root.addEventListener('mouseenter', function () { hold = true; root.classList.add('is-paused'); clearTimeout(timer); });
    root.addEventListener('mouseleave', function () { hold = false; root.classList.remove('is-paused'); restart(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else restart(); });
    var sx = 0, sy = 0, st = false;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = true; hold = true; clearTimeout(timer); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (!st) return; st = false; hold = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dx < 0 ? next() : prev(); } else restart();
    }, { passive: true });
    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') next(); else if (e.key === 'ArrowLeft') prev(); });
    // start the slideshow only once the first picture has painted, so it does not compete with the page load
    var go0 = function () { restart(); };
    if (window.requestIdleCallback) requestIdleCallback(go0, { timeout: 1500 }); else setTimeout(go0, 600);
    if (window.Shopify && Shopify.designMode) {
      root.addEventListener('shopify:block:select', function (e) { var k = slides.indexOf(e.target); if (k > -1) { hold = true; clearTimeout(timer); go(k, 1); } });
      root.addEventListener('shopify:block:deselect', function () { hold = false; restart(); });
    }
  }

  function cards(root) {
    if (root.__kz) return; root.__kz = true;
    var tr = $('[data-kz-track]', root), pv = $('[data-kz-prev]', root), nx = $('[data-kz-next]', root);
    if (!tr) return;
    function step() { var c = tr.firstElementChild; return c ? c.getBoundingClientRect().width + (parseFloat(getComputedStyle(tr).columnGap) || 0) : 300; }
    function upd() { if (pv) pv.disabled = tr.scrollLeft < 4; if (nx) nx.disabled = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4; }
    if (pv) pv.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (nx) nx.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    tr.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }

  function ba(root) {
    if (root.__kz) return; root.__kz = true;
    var r = $('[data-kz-range]', root), box = $('.kzba', root);
    if (!r) return;
    function set(v) { root.style.setProperty('--kz-p', v + '%'); }
    r.addEventListener('input', function () { set(r.value); if (box) box.classList.remove('is-hint'); });
    if (box && !reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { box.classList.add('is-hint'); io.disconnect(); } }); }, { threshold: .5 });
      io.observe(box);
    }
  }

  function init() {
    $$('[data-kzh]').forEach(hero); $$('[data-kz-cs]').forEach(cards); $$('[data-kz-ba]').forEach(ba);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* product page: frequently bought together + rotating review quotes */
(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function add(items) {
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok || d.status) throw new Error(d.description || 'error'); return d; }); })
      .then(function () {
        return fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
          var h = j['cart-icon-bubble']; var el = document.getElementById('cart-icon-bubble');
          if (h && el) { var t = document.createElement('div'); t.innerHTML = h; var n = t.querySelector('#cart-icon-bubble'); if (n) el.innerHTML = n.innerHTML; }
        }).catch(function () {});
      });
  }
  function flash(b, ok) { var o = b.getAttribute('data-l') || b.textContent; b.setAttribute('data-l', o); b.disabled = false; b.textContent = ok ? '✓' : 'Try again'; if (ok) b.classList.add('is-done'); setTimeout(function () { b.textContent = o; b.classList.remove('is-done'); }, 1800); }
  document.addEventListener('click', function (e) {
    var one = e.target.closest && e.target.closest('[data-kz-fbt-add]');
    var all = e.target.closest && e.target.closest('[data-kz-fbt-all]');
    if (!one && !all) return;
    e.preventDefault();
    var b = one || all, ids = one ? [one.getAttribute('data-id')] : $$('[data-kz-fbt-add]', b.closest('[data-kz-fbt]')).map(function (x) { return x.getAttribute('data-id'); });
    if (!ids.length) return;
    b.disabled = true;
    add(ids.map(function (i) { return { id: parseInt(i, 10), quantity: 1 }; })).then(function () { flash(b, true); }, function () { flash(b, false); });
  });
  function quotes(root) {
    if (root.__kzq) return; root.__kzq = true;
    var q = $$('.kzq__q', root); if (q.length < 2) return;
    var i = 0, ms = (parseInt(root.getAttribute('data-sec'), 10) || 5) * 1000;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setInterval(function () { if (document.hidden) return; q[i].classList.remove('is-on'); i = (i + 1) % q.length; q[i].classList.add('is-on'); }, ms);
  }
  function init() { $$('[data-kz-quotes]').forEach(quotes); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
